import type { CollectionPointsConfig } from '#types/config/components/collectionPoints'
import type { RecursivePartial } from '#types/utils'

export default {
  viewBtnVariant: 'tertiary'
} satisfies RecursivePartial<CollectionPointsConfig['search']>
